import {Outlet} from 'react-router-dom';
import {AppNavbar} from 'components';
import {useContext} from "react";
import {AuthContext} from "../contexts";

export const Layout = () => {
    const {user} = useContext(AuthContext);
    if (!user) {
        return <Outlet/>;
    }

    // The layout must be exactly viewport-high: if the document overflows the window,
    // focus()/scrollIntoView() scroll the (hidden) window scroll and content slides under the navbar.
    // position: relative + overflow: clip also contains absolutely positioned descendants
    // (e.g. the card's bottom button panel); clip, unlike hidden, can't be scrolled programmatically.
    return (
        <div className="d-flex flex-column vh-100 position-relative" style={{overflow: 'clip'}}>
            <AppNavbar/>
            <main className="flex-grow-1 overflow-auto" style={{minHeight: 0}}>
                <Outlet/>
            </main>
        </div>
    );
}
